import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=3e33df47&"
import script from "./AddressForm.vue?vue&type=script&lang=js&"
export * from "./AddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports